import { COMPANY_ROUTE } from '@constants'

export const API_BACKGROUND_JOB_URL = `${COMPANY_ROUTE}background-job/{job_id}/`
export const API_BACKGROUND_JOB_EMAIL_URL = `${API_BACKGROUND_JOB_URL}send-in-email/`
